import InfoHighlight from '@ui/InfoHighlight';
import { PersonCheckIcon, ShieldCheckIcon, SupportIcon } from './icons';

const ProductBanner = () => {
  return (
    <div className="mt-[6.4rem] flex flex-wrap items-center justify-center bg-[#EDEDED] py-[0.8rem] sm:mt-[1.6rem] sm:gap-[1.6rem] sm:py-[3.2rem]">
      <InfoHighlight
        icon={<PersonCheckIcon />}
        title="Buyer Protection"
        description="Simple returns, secure transactions, and human support. Money back is guaranteed if your item is received not as described."
      />
      <InfoHighlight
        icon={<ShieldCheckIcon />}
        title="Secure Transactions"
        description="Your safety and security are our priority. GearFocus never stores full payment card information on our servers."
      />
      <InfoHighlight
        icon={<SupportIcon />}
        title="Customer Support"
        description="In the unlikely event of a dispute, our gear experts are on hand to assist both the buyer and the seller to quickly resolve any dispute that arises."
      />
    </div>
  );
};

export default ProductBanner;
